<script>
import { mapGetters } from 'vuex'
import { http } from '@/services/api.service'
import { fetchDomainList } from '@/services/domains.service'
import CreateDomain from '@/pages/Domains/Modals/Create.vue'

const INTERNAL_HUB_UUID = '__internal_hub__'
const INTERNAL_HUB_LABEL = 'Équipe interne'
const INTERNAL_HUB_ROUTE_PREFIXES = [
  '/app/dashboard/tracking',
  '/dashboard/tracking'
]

export default {
  props: ['isFullWidth'],
  computed: {
    ...mapGetters([
      'domain',
      'roles'
    ]),
    canAccessInternalHub () {
      return this.roles.includes('admin') || this.roles.includes('community-manager')
    },
    isInternalHubRoute () {
      const path = String(this.$route?.path || '')
      return INTERNAL_HUB_ROUTE_PREFIXES.some(prefix => path.startsWith(prefix))
    },
    selectedDomainUuid () {
      if (this.isInternalHubRoute && this.canAccessInternalHub) {
        return INTERNAL_HUB_UUID
      }

      return this.domain?.uuid
    },
    selectedDomainLabel () {
      if (this.isInternalHubRoute && this.canAccessInternalHub) {
        return INTERNAL_HUB_LABEL
      }

      return this.domain?.label || 'Changer de domaine'
    },
    domainsSelectOptions () {
      const options = Array.isArray(this.domainsSearchResults) ? [...this.domainsSearchResults] : []

      if (this.canAccessInternalHub) {
        options.unshift(this.buildInternalHubOption())
      }

      return options
    }
    // roles () {
    //   const roles = this.$store.getters.roles
    //   if (['admin', 'community-manager'].some(role => roles.includes(role))) {
    //     this.getDomains()
    //   }
    //   return roles
    // }
  },
  data () {
    return {
      searchTerm: '',
      domains: [],
      domainsSearchResults: [],
      storageUrl: process.env.VUE_APP_STORAGE_URL
    }
  },
  mounted () {
    // this.getRoles().then(() => {
    //   if (['admin', 'community-manager', 'director'].some(role => this.roles.includes(role))) {
    //     this.getDomains()
    //   }
    // })
    this.getRoles().then(() => {
      this.getDomains()
    })
  },
  methods: {
    getRoles () {
      return this.$store.dispatch('FETCH_ROLES')
    },
    selectDomain (domain) {
      this.$store.commit('SET_DOMAIN', domain)
      this.$emit('domainChange')
      // this.getMyRequests()
      // this.getPendingRequests()
      this.getRoles()
    },
    domainRemoved (domain) {
      this.domains = this.domains.filter(d => domain.uuid !== d.uuid)
      this.selectDomain(this.domains[0])
    },
    buildInternalHubOption () {
      return {
        uuid: INTERNAL_HUB_UUID,
        label: INTERNAL_HUB_LABEL,
        is_internal_hub: true
      }
    },
    getDomains ({ force = false } = {}) {
      let endpoint = '/domain'
      if ((this.roles.includes('director') || this.roles.includes('manager') || this.roles.includes('operator')) && !this.roles.includes('admin') && !this.roles.includes('community-manager')) {
        endpoint = 'me/domains-where-not-user'
      }
      return fetchDomainList(endpoint, { force }).then(domains => {
        const filtered = domains.filter(domain => domain?.application?.slug !== 'disabled')
        this.domains = filtered
        this.domainsSearchResults = filtered
      }).catch(err => {
        console.log(err)
      })
    },
    createDomain () {
      this.$buefy.modal.open({
        parent: this,
        component: CreateDomain,
        hasModalCard: true,
        width: 800,
        destroyOnHide: false,
        ariaRole: 'dialog',
        ariaModal: true,
        events: {
          created: (created) => {
            this.getDomains({ force: true }).finally(() => {
              this.selectDomain(created)
              this.$buefy.notification.open({
                duration: 4000,
                message: 'Le domaine a été créée avec succès !',
                position: 'is-bottom-left',
                type: 'is-success',
                hasIcon: true
              })
            })
          }
        }
      })
    },
    async handleDomainChange (domaineUuid) {
      if (domaineUuid === INTERNAL_HUB_UUID) {
        if (!this.canAccessInternalHub) {
          return
        }

        if (!this.isInternalHubRoute) {
          await this.$router.push('/app/dashboard/tracking/employees/general')
        }

        return
      }

      try {
        const { data } = await http.get(`/domain/${domaineUuid}`)
        this.selectDomain(data)

        if (this.isInternalHubRoute) {
          window.location.href = '/app/dashboard'
          return
        }

        window.location.reload()
      } catch (err) {
        console.log(err)
        this.$buefy.toast.open({
          message: 'Vous n\'avez pas accès à ce domaine.',
          type: 'is-danger'
        })
        this.getDomains()
      }
    }
  }
}
</script>

<template>
  <div
    :class="{ 'w-full' : isFullWidth }"
    >
    <!-- <t-rich-select
      v-if="['admin', 'director', 'community-manager'].some(role => roles.includes(role))"
      :options="domainsSearchResults"
      placeholder="Changer de domaine"
      value-attribute="uuid"
      text-attribute="label"
      :value="domain.uuid"
      @change="handleDomainChange"
      variant="domainSelect"
    > -->
    <t-rich-select
      :options="domainsSelectOptions"
      placeholder="Changer de domaine"
      value-attribute="uuid"
      text-attribute="label"
      :value="selectedDomainUuid"
      @change="handleDomainChange"
      variant="domainSelect"
    >
      <template
        slot="label"
      >
        <div class="flex bg-transparent items-center text-xs">
          <div
            class="rounded-full h-8 w-8 bg-blue-600 flex items-center justify-center text-white"
            v-if="isInternalHubRoute && canAccessInternalHub"
          >
            <i class="fa-solid fa-briefcase text-xs" />
          </div>
          <div
            class="rounded-full h-8 w-8"
            :style="`background-color: ${domain.color}`"
            v-else-if="domain.logo"
          >
            <img
              :src="storageUrl + '/logos/' + domain.logo"
              class="block h-8 w-8"
              alt=""
            />
          </div>
          <div class="pl-3">
            {{ selectedDomainLabel }}
          </div>
        </div>
      </template>
      <template
        slot="option"
        slot-scope="{ index, isHighlighted, isSelected, className, option }"
      >
        <div class="flex p-2 text-xs items-center">
          <div
            class="rounded-full h-4 w-4 bg-blue-600 flex items-center justify-center text-white"
            v-if="option.raw.is_internal_hub"
          >
            <i class="fa-solid fa-briefcase text-[8px]" />
          </div>
          <div
            class="rounded-full h-4 w-4"
            :style="`background-color: ${option.raw.color}`"
            v-else-if="option.raw.logo"
          >
            <img
              :src="storageUrl + '/logos/' + option.raw.logo"
              class="block h-4 w-4"
              alt=""
            />
          </div>
          <div class="pl-3">
            {{ option.raw.label }}
          </div>
        </div>
      </template>

      <template slot="dropdownDown">
        <div class="p-2 text-xs w-full">
          <t-button class="w-full" @click="createDomain">
            + Créer un domaine
          </t-button>
        </div>
      </template>
    </t-rich-select>
    <!-- <div
      v-else
      class="text-white flex flex-shrink-0 items-center pr-3 border-r border-primary-200 border-opacity-25"
    >
      <div
        class="rounded-full h-8 w-8"
        :style="`background-color: ${domain.color}`"
        v-if="domain.logo"
      >
        <img
          :src="storageUrl + '/logos/' + domain.logo"
          class="block h-8 w-8"
          alt=""
        />
      </div>
      <div class="pl-3">
        {{ domain.label  }}
      </div>
    </div> -->
  </div>
</template>
